import React from "react";
import { TShortTextValue } from "../App.type";

type TPreviewModeProps = {
  value: TShortTextValue;
  componentType?: string;
};

const ComponentTypes = ["div", "h1", "h2"];

const PreviewMode = (props: TPreviewModeProps) => {
  const {
    value: { value: text },
    componentType = "div",
  } = props;

  const ShortTextPreviewModeContent = () => {
    const tag = ComponentTypes.includes(componentType) ? componentType : "div";
    return React.createElement(
      tag,
      {
        className: "tpd-short-text-preview-mode-container",
        style: { width: "100%" },
      },
      text
    );
  };

  return text && <ShortTextPreviewModeContent />;
};

export default PreviewMode;
